export default "__VITE_ASSET__Cg4YUE1f__"